<template>
  <div
    class="sj-tree-node-container"
    :class="'sj-tree-node-container-layer__' + layer"
    v-if="!node.hide"
  >
    <div
      class="sj-tree-content"
      :class="[
        { 'sj-tree-content__checked': node.isChecked },
        'sj-tree-content-layer__' + layer
      ]"
      @click="handleItemClick"
    >
      <sj-checkbox
        v-if="compoundOptional || !Array.isArray(node.children)"
        class="check-box"
        v-model="node.isChecked"
        :indeterminate="node.selectAllStatus === 'indeterminate'"
        @change="handleCheckedClick"
        size="mini"
      ></sj-checkbox>
      <div v-else>
        <i
          class="icon_xh iconunfold"
          :class="node.isExpanded ? 'transform--expand' : 'transform--merge'"
        ></i>
      </div>

      <span class="sj-tree-label" :title="node.label">{{ node.label }}</span>
      <div
        class="right-area"
        :class="{ 'drop-down': node.children && node.children.length }"
      >
        <span class="count">{{ node.count }}</span>
        <i
          class="iconfont drop-down-icon"
          :class="node.isExpanded ? 'icon-down' : 'icon-up'"
        ></i>
      </div>
    </div>

    <sj-collapse :value="node.isExpanded">
      <div>
        <tree-node
          @check="handleCheckEvent"
          @expandChange="emitExpandChange"
          :node-key="nodeKey"
          :layer="layer + 1"
          v-for="child in node.children"
          :key="getNodeKey(child)"
          :node="child"
          :compound-optional="compoundOptional"
        ></tree-node>
      </div>
    </sj-collapse>
  </div>
</template>

<script>
export default {
  name: "TreeNode",

  props: {
    node: {
      default: {}
    },

    nodeKey: {
      type: String
    },

    layer: {
      type: Number // 当前的层级
    },

    compoundOptional: {
      default: true
    }
  },

  data() {
    return {
      value: false,
      expanded: false,
      selectAllStateCheckMapper: Object.freeze({
        none: "all",
        indeterminate: "all",
        all: "none"
      })
    };
  },

  computed: {},

  created() {},

  watch: {
    "node.children": {
      deep: true,
      immediate: true,
      handler() {
        if (!this.node.children || !this.node.children.length) {
          return;
        }

        if (this.node.children.every(item => item.isChecked)) {
          this.node.selectAllStatus = "all";
          this.node.isChecked = true;
        } else if (this.node.children.every(item => !item.isChecked)) {
          this.node.selectAllStatus = "none";
          this.node.isChecked = false;
        } else this.node.selectAllStatus = "indeterminate";

        if (
          this.node.children.some(
            item => item.selectAllStatus === "indeterminate"
          )
        ) {
          this.node.selectAllStatus = "indeterminate";
        }
      }
    }
  },

  methods: {
    getNodeKey(node) {
      return node[this.nodeKey];
    },

    handleItemClick() {
      const isExpanded = !this.node.isExpanded;
      this.node.isExpanded = isExpanded;
      this.emitExpandChange(
        this.node[this.nodeKey],
        isExpanded,
        this.node.label
      );
    },

    emitExpandChange(key, value, name) {
      this.$emit("expandChange", key, value, name);
    },

    handleCheckedClick(checkedValue) {
      this.checkAllSubsetValue(checkedValue, this.node.children);

      this.$emit("check", this.node);
    },

    checkAllSubsetValue(checkedValue, nodes) {
      if (Array.isArray(nodes)) {
        nodes.forEach(item => {
          item.isChecked = checkedValue;
          if (Array.isArray(item.children) && item.children.length > 0) {
            this.checkAllSubsetValue(checkedValue, item.children);
          }
        });
      }
    },

    handleCheckEvent(node) {
      this.$emit("check", node);
    }
  }
};
</script>

<style scoped lang="less">
@import "tree-constant";
.sj-tree-content-layer__0 {
  // font-weight: 600;
}
.sj-tree-node-container {
  padding-left: @tree-node-layer-padding-left;
  font-size: @xh-font-size;

  .sj-tree-content {
    color: @color-label-switch-1;
    height: @tree-node-height;
    cursor: pointer;
    display: flex;
    align-items: center;

    .check-box {
      margin-right: 6px;
    }

    .sj-tree-label {
      text-align: left;
      .text-ellipsis();
    }

    .iconunfold {
      transition: transform 0.3s;
      font-size: 20px;
      display: block;
      color: @color-normal;
      &.transform--expand {
        transform: rotate(0);
      }

      &.transform--merge {
        transform: rotate(-90deg);
      }
    }

    .right-area {
      display: flex;
      margin-left: auto;
      .count {
        font-size: @xh-font-size;
        font-weight: 300;
        color: @color-light;
        margin-right: 5px;
      }

      .drop-down-icon {
        display: block;
        color: @color-normal;
        visibility: hidden;
        font-weight: 300;
      }
    }

    .drop-down {
      .drop-down-icon {
        visibility: visible;
      }
    }
  }

  .sj-tree-content__checked {
    color: @color-highlight;
  }
}

.sj-tree-node-container-layer__0 {
  padding-left: 0;
}
</style>
